/* eslint react/no-array-index-key: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";

function _getLastString({ index, lastIndex, fullString }) {
	const lastString = fullString.slice(lastIndex, index);

	if (lastString && lastString.length) {
		return lastString;
	} else {
		return null;
	}
}

function _isEmpty(obj) {
	if (!obj) {
		return true;
	}

	if (obj.constructor === Object) {
		if (!Object.keys(obj).length) {
			return true;
		}
	} else if (!obj.length) {
		return true;
	}

	return false;
}


class Strf extends Component {
	static propTypes = {
		children: PropTypes.node,
		vars: PropTypes.object,
	};

	shouldComponentUpdate(nextProps) {
		if (JSON.stringify(nextProps.children) !== JSON.stringify(this.props.children)) {
			return true;
		}

		if (nextProps.vars !== this.props.vars) {
			return true;
		}

		return false;
	}


	// if you substantially change this, also make those changes to
	// localization.js!

	render() {
		const { children, vars, ...props } = this.props;
		let str;

		if (typeof (children) === "string") {
			str = children;
		} else if (children && children.length) {
			str = `${children[0]}`;
		} else {
			str = "";
		}

		str = _str(str);

		// this component supports react element vars.
		// so it has to reimplement a lot of stuff in _strf
		// (which only supports string replacements)
		if (!_isEmpty(vars)) {
			let replacements;

			// since the first key is "1", and arrays are zero-indexed,
			// prepend the replacements field with a dummy entry
			if (vars.constructor === Array) {
				replacements = ([""]).concat(vars);
			} else {
				replacements = vars;
			}

			const strArray = [];
			let lastIndex = 0;
			let lastString;

			// use replace, because it gets matches
			// (but don't actually replace anything)
			str.replace(/\$(\d+|\w+)/g, (match, p1, index) => {
				const repl = replacements[p1];

				lastString = _getLastString({
					lastIndex,
					fullString: str,
					index: index,
				});

				if (lastString) {
					strArray.push(
						<span key={strArray.length}>
							{lastString}
						</span>
					);
				}

				strArray.push(
					<span key={strArray.length}>
						{repl}
					</span>
				);

				lastIndex = index + match.length;

				return match;
			});

			// add the last shit
			lastString = _getLastString({
				lastIndex,
				index: str.length,
				fullString: str,
			});

			if (lastString) {
				strArray.push(
					<span key={strArray.length}>
						{lastString}
					</span>
				);
			}

			str = strArray;
		} else {
			// Map in render expects an array, so don't disappoint
			str = [str];
		}

		return (
			<span {...props}>
				{str.map((s, i) =>
					<span key={i}>{s}</span>
				)}
			</span>
		);
	}
}

export default Strf;



// WEBPACK FOOTER //
// ./src/shared/components/Strf.jsx